export enum RadiusEnum {
  m = 'm',
  l = 'l'
}

export enum ThemeEnum {
  qiwi = 'qiwi',
  violet = 'violet'
}

export type TabItemKey = string | number
export type TabItem = Record<TabItemKey, unknown>
export type TabItems = Array<string> | Array<TabItem>

export type Radius = RadiusEnum.m | RadiusEnum.l
export type Theme = ThemeEnum.qiwi | ThemeEnum.violet
